import useSWR from 'swr';
import axiosInstance from '@/lib/axios';

export type DirectoryAccessReason =
  | 'allowed'
  | 'disabled'
  | 'sign_in'
  | 'join'
  | 'pending'
  | 'invited';

export interface BusinessDirectoryAccessResponse {
  directoryPublic: boolean;
  canView: boolean;
  reason: DirectoryAccessReason;
}

const fetcher = (url: string) =>
  axiosInstance.get<BusinessDirectoryAccessResponse>(url).then((res) => res.data);

export function useBusinessDirectoryAccess(communityId: string | undefined) {
  const url = communityId ? `/api/communities/${communityId}/business/access` : null;

  const { data, error, isLoading } = useSWR<BusinessDirectoryAccessResponse>(url, fetcher, {
    revalidateOnFocus: true,
  });

  return {
    access: data,
    isLoading,
    isError: error,
  };
}
